<template>
  <div>
    <qr-to-html
      ref="html2Pdf"
      @hasDownloaded="hasDownloaded()"
      :dataList="[vg_selected]"
      :fileName="fileName"
    />
    <QrImageDownloaderNew
      @hasDownloaded="imageDownloaded()"
      :dataList="[vg_selected]"
      :enableDownload="enableImageDownload"
      @keydown.esc="vm_setQrDialog(false)"
    />
    <v-dialog
      persistent
      @keydown.esc="vm_setQrDialog(false)"
      :value="vg_qrDialog"
      max-width="460px"
      class="pt-0"
    >
      <v-card
        min-height="400px"
        class="pt-0 overflow-hidden d-flex justify-center flex-column align-stretch"
      >
        <v-card-title class="text-h5 pt-0 d-flex justify-end align-auto">
          <div style="flex: 1"></div>
          <div style="flex: 1">
            <v-img
              v-if="vg_activeBusinessLogo"
              :src="vg_activeBusinessLogo"
              contain
              width="80"
              height="80"
              class="ma-auto"
            ></v-img>
            <p v-else class="primary--text font-weight-bold">
              {{ vg_selectedBusiness.name }}
            </p>
          </div>
          <div style="flex: 1">
            <div class="d-flex justify-center align-center flex-column primary px-3 pt-4 pb-11 ml-auto badge" style="width: max-content">
              <p class="white--text caption ma-0" style="line-height: 0.75rem">TABLE #</p>
              <h3 class="white--text ma-0">{{ vg_selected.table_number }}</h3>
              <span class="badge_design"></span>
            </div>
          </div>
        </v-card-title>
        <div class="main_wrapper_qr pt-6 overflow-hidden">
          <div class="background_design primary"></div>
          <div class="qr-content">
            <v-container fluid>
              <v-layout column align-center>
                <div class="qr-wrapper">
                  <qrcode-vue
                    :value="qrValue"
                    :renderAs="renderAs"
                    :size="size"
                    :level="level"
                    :background="background"
                    :foreground="foreground"
                    slot="pdf-content"
                  />
                </div>
              </v-layout>
            </v-container>
            <!-- <v-card-text class="white--text text-h5 font-weight-bold" align="center">
            SCAN QR CODE
          </v-card-text> -->
            <v-layout
              justify-space-between
              align-center
              class="white primary--text pt-3 pb-0 px-8 mx-0 mt-3"
            >
              <p class="font-weight-bold mt-1">Menu</p>
              <p class="font-weight-bold mt-1">Order</p>
              <p class="font-weight-bold mt-1">Server</p>
              <p class="font-weight-bold mt-1">Pay</p>
            </v-layout>
            <v-card-text class="ma-0 py-4">
              <div class="d-flex justify-center align-center white--text">
                <!-- <p class="ma-0 pa-0">POWERED BY</p> -->
                <span class="px-1"></span>
                <div>
                  <img
                    :src="getImage()"
                    width="50"
                    class="primary"
                  />
                </div>
              </div>
            </v-card-text>
          </div>
        </div>
        <v-card-actions class="justify-center my-2">
          <v-btn
            depressed
            color="primary"
            @click="downloadImage()"
            :loading="isLoading"
            :disabled="isLoading"
          >
            Download Image
          </v-btn>
          <v-btn
            depressed
            color="primary"
            @click="downloadPDF()"
            :loading="isLoading"
            :disabled="isLoading"
          >
            <v-icon left>
              mdi-arrow-down-circle
            </v-icon>
            Download PDF
          </v-btn>
          <v-btn depressed color="primary" @click="vm_setQrDialog(false)">
            <!-- <v-btn depressed color="primary" @click="showLayout = !showLayout"> -->
            <v-icon left>
              mdi-check
            </v-icon>
            Done
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import QrToHtml from '@/components/custom-components/QrToHtml'
import { GR8TABLE_URL } from '@/clients/env.js'
import QrImageDownloader from '@/components/custom-components/QrImageDownloader.vue'
import QrImageDownloaderNew from '@/components/custom-components/QrImageDownloaderNew.vue'

export default {
  name: 'SingleQRDialog',
  components: {
    QrcodeVue,
    QrToHtml,
    QrImageDownloader,
    QrImageDownloaderNew
  },
  data() {
    return {
      size: 200,
      level: 'L',
      background: '#ffffff',
      foreground: '#000000',
      renderAs: 'canvas',
      showLayout: false,
      isLoading: false,
      enableImageDownload: false
    }
  },
  computed: {
    ...mapGetters({
      vg_qrDialog: 'table/isQrDialog',
      vg_selected: 'table/getSelected',
      vg_selectedLocation: 'auth/selectedLocation',
      vg_selectedBusiness: 'auth/activeBusiness',
      vg_activeBusinessLogo: 'auth/activeBusinessLogo'
    }),
    fileName() {
      return `table-name-${this.vg_selected.table_number}.pdf`
    },
    qrValue() {
      return `${GR8TABLE_URL}/${this.vg_selectedBusiness.slug}/${this.vg_selectedLocation.slug}/menu?allow_to_join=true&receive_method=dinein&table_id=${this.vg_selected.table_number}`
    }
  },
  methods: {
    hasDownloaded() {
      this.isLoading = false
    },
    downloadPDF() {
      this.isLoading = true
      this.$refs.html2Pdf.generatePdf()
    },
    imageDownloaded() {
      this.enableImageDownload = false
    },
    downloadImage() {
      this.enableImageDownload = true
    },
    ...mapMutations({
      vm_setQrDialog: 'table/SET_DIALOG_QRCODE'
    }),
    getImage() {
      return require(`../../assets/images/gr8table-${this.$vuetify.theme.themes.light.primary === '#ffffff' ? 'black' : 'white'}.png`)
    }
  }
}
</script>

<style scoped>
.main_wrapper_qr {
  position: relative;
}
.background_design {
  position: absolute;
  width: 600px;
  height: 600px;
  border-radius: 50%;
  z-index: 0;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
.qr-content {
  position: relative;
  z-index: 10;
}
.qr-wrapper {
  border-radius: 10%;
  background-color: white;
  padding: 20px;
  padding-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.badge {
  position: relative;
  min-width: fit-content;
  height: 100px;
  overflow: hidden;
}
.badge_design {
  position: absolute;
  top: 100%;
  background-color: white;
  width: 188px;
  height: 188px;
  transform: rotate(-45deg);
}
</style>
